/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSubscriptionSendContractModel,
  ISubscriptionSendContractRequest,
  IMappers,
  ISubscriptionSendContractResponse,
  ISubscriptionSendContractResponseError,
  TSubscriptionSendContractResponse,
} from './types';

const defaultConfig: TSubscriptionSendContractModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 204, 400],
  method: 'POST',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/subscription-send-contract/',
  hostType: 'ud-api',
} as TSubscriptionSendContractModel;

function createSubscriptionSendContractModel(
  parameters: ISubscriptionSendContractRequest,
): TSubscriptionSendContractModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISubscriptionSendContractOptions<TResponse200, TResponse204, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISubscriptionSendContractRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse204, TResponse400>;
}

async function fetchSubscriptionSendContract<TResponse200, TResponse204, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISubscriptionSendContractOptions<TResponse200, TResponse204, TResponse400>): Promise<
  TResponse200 | TResponse204 | TResponse400 | TSubscriptionSendContractResponse
> {
  const { response, statusCode } = await httpApi.fetch(createSubscriptionSendContractModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISubscriptionSendContractResponse);
    }

    if (statusCode === 204) {
      return mappers[204]();
    }

    if (statusCode === 400) {
      return mappers[400](response as ISubscriptionSendContractResponseError);
    }
  }

  return { response, statusCode } as TSubscriptionSendContractResponse;
}

export { defaultConfig, createSubscriptionSendContractModel, fetchSubscriptionSendContract };
